/** A feed card's anchor: the article cards' existing attribute, or the plain card's. */
const selectorFor = (postId: string) => {
  const id = CSS.escape(postId)
  return `[data-article-anchor="${id}"], [data-feed-post="${id}"]`
}

/**
 * Scrolls the feed to a post once its card has rendered, polling briefly
 * because the feed's first page arrives after navigation. Returns a cancel.
 */
export function scrollToPostWhenReady(postId: string, timeoutMs = 5000): () => void {
  const started = Date.now()
  let frame = 0
  const tick = () => {
    const card = document.querySelector<HTMLElement>(selectorFor(postId))
    if (card) {
      card.scrollIntoView({ block: "start", behavior: "smooth" })
      return
    }
    if (Date.now() - started < timeoutMs) frame = window.requestAnimationFrame(tick)
  }
  frame = window.requestAnimationFrame(tick)
  return () => window.cancelAnimationFrame(frame)
}
